// ----------------------------------------------------------------------
// <copyright file="Izenda.Performance.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Performace component
 */
!(function () {
  var React = require('react');

  var IconMenu = require('share/components/controls/Izenda.IconMenu');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var ActionBar = require('share/components/controls/Izenda.ActionBar');
  var Alert = require('share/components/controls/Izenda.Alert');
  var EventsUtils = require('EventUtils');

  var actions = require('./Izenda.PerformanceAction');

  var Validator = require('share/components/hoc/Izenda.Validator');
  var Input = Validator()(require('share/components/controls/Izenda.Input'));
  var constants = require('logic/data/Izenda.PerformanceConstants');
  var connect = require('share/enhancers/Izenda.Connect');

  var PerformanceAlert = connect()(function (props) {
    var alertMessage = this.props.performanceModel.alertMessage;

    return (
      <div className="izenda-Alert-container">
        <Alert type={alertMessage.type}>
          {alertMessage.message}
        </Alert>
      </div>
    );
  });

  var PerformanceGrid = connect()(function (props) {
    var notifyChange = EventsUtils.notifyChange;
    var store = props.store;
    var performanceModel = store.performanceModel;
    var localization = props.localization;

    function renderFormgroupItem(label, title, input, resetFuntion) {
      return (
        <div className='form-group item'>

          <span className='col-md-7 col-xs-5 control-label'>
            {label} &nbsp; <span className='icon-info-circled' title={title}></span>
          </span>

          <div className='col-md-3 col-xs-6'>
            {input}
          </div>

          <div className='col-md-2 col-xs-1 control-label'>
            <span className='icon-ccw resetButton'
                onClick={resetFuntion}
                title={localization.getText('PERFORMANCE_RESET_TO_DEFAULT')}></span>
          </div>

        </div>
      );
    }

    function renderTimeoutInput() {
      return (
        <div className="u_table">
          <Input
            type="text"
            name={constants.FIELD_NAMES.QUERY_TIME_OUT}
            className="form-control"
            maxLength={6}
            value={performanceModel.queryTimeoutValue}
            onChange={notifyChange(performanceModel.updateValue.bind(performanceModel, constants.FIELD_NAMES.QUERY_TIME_OUT), EventsUtils.INPUT)}
            validations={constants.getLimitConstraint(constants.FIELD_NAMES.QUERY_TIME_OUT)}
            field={constants.FIELD_NAMES.QUERY_TIME_OUT}/>

          <span className="u_tableCell">&nbsp;(s)</span>
        </div>
      );
    }

    function renderNoLockInput() {
      return (
        <Input
          type="checkbox"
          name="noLock"
          checked={performanceModel.useNoLockValue}
          onChange={notifyChange(performanceModel.updateValue.bind(performanceModel, 'useNoLock'), EventsUtils.CHECKBOX)} />
      );
    }

    function renderDataSourceInput() {
      return (
        <Input
          type="text"
          name={constants.FIELD_NAMES.DATA_SOURCE_LIMIT}
          className="form-control"
          maxLength={6}
          value={performanceModel.dataSourceLimitValue}
          onChange={notifyChange(performanceModel.updateValue.bind(performanceModel, constants.FIELD_NAMES.DATA_SOURCE_LIMIT), EventsUtils.INPUT)}
          validations={constants.getLimitConstraint(constants.FIELD_NAMES.DATA_SOURCE_LIMIT)}
          field={constants.FIELD_NAMES.DATA_SOURCE_LIMIT} />
      );
    }

    function renderFieldLimitInput() {
      return (
        <Input
          type="text"
          name={constants.FIELD_NAMES.FIELD_LIMIT}
          className="form-control"
          maxLength={6}
          value={performanceModel.fieldLimitValue}
          onChange={notifyChange(performanceModel.updateValue.bind(performanceModel, constants.FIELD_NAMES.FIELD_LIMIT), EventsUtils.INPUT)}
          validations={constants.getLimitConstraint(constants.FIELD_NAMES.FIELD_LIMIT)}
          field={constants.FIELD_NAMES.FIELD_LIMIT} />
      );
    }

    function renderQueryLimitInput() {
      return (
        <Input
          type="text"
          name={constants.FIELD_NAMES.QUERY_LIMIT}
          className="form-control"
          maxLength={10}
          value={performanceModel.queryLimitValue}
          onChange={notifyChange(performanceModel.updateValue.bind(performanceModel, constants.FIELD_NAMES.QUERY_LIMIT), EventsUtils.INPUT)}
          validations={constants.getLimitConstraint(constants.FIELD_NAMES.QUERY_LIMIT)}
          field={constants.FIELD_NAMES.QUERY_LIMIT} />
      );
    }

    function renderPivotColumnLimitInput() {
      return (
        <Input
          type="text"
          name={constants.FIELD_NAMES.PIVOT_COLUMN_LIMIT}
          className="form-control"
          maxLength={6}
          value={performanceModel.pivotColumnLimitValue}
          onChange={notifyChange(performanceModel.updateValue.bind(performanceModel, constants.FIELD_NAMES.PIVOT_COLUMN_LIMIT), EventsUtils.INPUT)}
          validations={constants.getLimitConstraint(constants.FIELD_NAMES.PIVOT_COLUMN_LIMIT)}
          field={constants.FIELD_NAMES.PIVOT_COLUMN_LIMIT} />
      );
    }

    function renderFilterLimitInput() {
      return (
        <Input
          type="text"
          name={constants.FIELD_NAMES.FILTER_LIMIT}
          className="form-control"
          maxLength={6}
          value={performanceModel.filterLimitValue}
          onChange={notifyChange(performanceModel.updateValue.bind(performanceModel, constants.FIELD_NAMES.FILTER_LIMIT), EventsUtils.INPUT)}
          validations={constants.getLimitConstraint(constants.FIELD_NAMES.FILTER_LIMIT)}
          field={constants.FIELD_NAMES.FILTER_LIMIT} />
      );
    }

    return (
      <div className='form-horizontal' role='form'>
        <div className='form-group'>
          <strong className='col-md-7 col-xs-6 control-label'>
            {localization.getText("COMMON_LABEL_NAME")}
          </strong>
          <strong className='col-md-5 col-xs-6 control-label'>
            {localization.getText("COMMON_LABEL_VALUE")}
          </strong>
        </div>

        {renderFormgroupItem(localization.getText("PERFORMANCE_LABEL_QUERY_TIMEOUT"),
            localization.getText('PERFORMANCE_TIMEOUT_TOOLTIP'),
            renderTimeoutInput(),
            performanceModel.resetValue.bind(performanceModel, 'queryTimeout'))}

        {renderFormgroupItem(localization.getText("PERFORMANCE_LABEL_USE_NO_LOCK"),
            localization.getText('PERFORMANCE_NOLOCK_TOOLTIP'),
            renderNoLockInput(),
            performanceModel.resetValue.bind(performanceModel, 'useNoLock'))}

        {renderFormgroupItem(localization.getText("PERFORMANCE_LABEL_DATA_SOURCE_LIMIT"),
            localization.getText('PERFORMANCE_DATASOURCE_TOOLTIP'),
            renderDataSourceInput(),
            performanceModel.resetValue.bind(performanceModel, 'dataSourceLimit'))}

        {renderFormgroupItem(localization.getText("PERFORMANCE_FIELD_LIMIT"),
            localization.getText('PERFORMANCE_FIELD_LIMIT_TOOLTIP'),
            renderFieldLimitInput(),
            performanceModel.resetValue.bind(performanceModel, 'fieldLimit'))}

        {renderFormgroupItem(localization.getText("PERFORMANCE_QUERY_LIMIT"),
            localization.getText('PERFORMANCE_QUERY_LIMIT_TOOLTIP'),
            renderQueryLimitInput(),
            performanceModel.resetValue.bind(performanceModel, 'queryLimit'))}

        {renderFormgroupItem(localization.getText("PERFORMANCE_PIVOT_COLUMN_LIMIT"),
            localization.getText('PERFORMANCE_PIVOT_COLUMN_LIMIT_TOOLTIP'),
            renderPivotColumnLimitInput(),
            performanceModel.resetValue.bind(performanceModel, 'pivotColumnLimit'))}

        {renderFormgroupItem(localization.getText("PERFORMANCE_FILTER_LIMIT"),
            localization.getText('PERFORMANCE_FILTER_LIMIT_TOOLTIP'),
            renderFilterLimitInput(),
            performanceModel.resetValue.bind(performanceModel, 'filterLimit'))}
        
      </div>
    );
  });

  var Performance = React.createClass({
    propTypes: {
      store: React.PropTypes.object.isRequired
    },

    componentDidMount: function() {
      var loader = this.props.loader;
      var store = this.props.store;

      loader.startLoading();
      store.init().finally(loader.endLoading.bind(loader));
    },

    componentWillUnmount: function() {
      this.props.store.destroy();
    },

    render: function () {
      var props = this.props;
      var performanceModel = props.store.performanceModel;

      return (
        <div className="izenda-Wrapper">
          <div className="izenda-Wrapper-header">
            <IconMenu />

            <PerformanceAlert performanceModel={performanceModel} />

            <ActionBar onSave={props.onSave} onCancel={props.onCancel} />
          </div>

          <div className="izenda-Wrapper-content">
            <GridLayout className="u_fullHeight u_paddingLeftRight">
              <GridLayout.Row>
                <GridLayout.Col>

                  <PerformanceGrid {...props} />

                </GridLayout.Col>
              </GridLayout.Row>
            </GridLayout>
          </div>
        </div>
      );
    }
  });

  module.exports = connect(actions)(Performance);
}());



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/AdvancedSetting/Izenda.Performance.jsx